import React, { useEffect, useState } from 'react'
import { Link,useParams,useNavigate } from 'react-router-dom';
import Header from '../Components/Header';
import Image from '../Assets/print.gif'
import axios from 'axios';



const EstimateListDetails = () => {
const {estimate_id} = useParams();
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const navigate = useNavigate();
const[estimatedetails,setEstimateDetails] = useState([]);
const [status, setStatus] = useState("");
 

useEffect(() => {
  axios.post(`${API_BASE_URL}estimate_list_details.php`, { estimate_id })
    .then((response) => {
      if (response.data.head.code === 200) {
        setEstimateDetails(response.data.body);
        setStatus(response.data.body.status);
      } else {
        console.error("Error Fetching Data:", response.data.head.msg);
      }
    })
    .catch((error) => {
      console.error("API Error:", error);
    });
}, [API_BASE_URL, estimate_id]); // ✅ dependency array to prevent infinite calls
/* const handleCancel = async (orderNo) => {
  console.log(orderNo);
  try {
    const response = await axios.post(
      "https://www.aatheshsoft.com/admin_api/cancel_product.php",
      { order_no: orderNo }
    );

    if (response.data.head.code === 200) {
      alert("Product canceled successfully!");
      // You may also update state here to reflect changes in the UI
    } else {
      alert("Failed to cancel product: " + response.data.message);
    }
  } catch (error) {
    console.error("Error canceling product:", error);
    alert("An error occurred while canceling the product.");
  }
}; */

/* const Handleupdate = async () => {
  console.log("clicked") 
} */
const Handleupdate = async (e) => {
  e.preventDefault();

  try {
    const response = await axios.post(`${API_BASE_URL}update_paid_status.php`,
      // "https://manifriendstraders.com/admin_api/update_paid_status.php",
      {
        estimate_id: estimate_id,
        status: status === "Paid" ? "Paid" : "Delivered" ? "Delivered" : "Pending",
      }
    );

    console.log("Response:", response.data);

    if (response.data.head.code === 200) {
      alert("Status updated successfully!");
      navigate('/estimate');
    } else {
      alert("Update failed!");
    }
  } catch (error) {
    console.error("Error updating status:", error);
    alert("An error occurred!");
  }
};
  return (
    <>
    <Header />
    <div class="page-wrapper compact-wrapper" id="pageWrapper">
      <div class="page-body-wrapper">
        <div class="page-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-12">
                <div class="card card-table">
                  <div class="card-body">
                    <div class="title-header option-title d-sm-flex d-block">
                      <h5> Estimate Details</h5>
                      <div class="right-options">
                        <ul>
                          <li>
                            <Link class="btn btn-solid" to="/estimate">Back</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table theme-table table-product" id="table_id">
                       {/*  <!-- Order Summary --> */}
                        <tr>
                          <td>
                            <table width="100%" cellspacing="0" cellpadding="0" border="0">
                              <tr>
                                <td class="blacktext"><b>Estimate ID:</b> {estimatedetails.estimate_id}</td>
                             
                                <td rowspan="2" align="right">
                                    <a 
                                      href={`/estimateinvoice/${estimatedetails.estimate_id}`} 
                                      target="_blank" 
                                      rel="noopener noreferrer"
                                    >
                                      <img src={Image} alt="Print" border="0" />
                                    </a>
                                  </td>

                              </tr>
                              <tr>
                          <td class="blacktext"><b>Estimate Date:</b> {estimatedetails.estimatedate}</td>
                        </tr>
                             {/*  <tr>
                                <td class="blacktext"><b>Customer Name:</b>{orderdetails.billing_name}</td>
                              </tr> */}
                            </table>
                          </td>
                        </tr>
                       {/*  <tr>
                          <td class="blacktext"><b>Email:</b> {orderdetails.email}</td>
                        </tr>
                        <tr>
                          <td class="blacktext"><b>Mobile Number:</b> {orderdetails.mobile}</td>
                        </tr> */}
                       
                      {/*   <!-- Billing & Shipping Information --> */}
                        <tr>
                          <td>
                            <table width="100%" align="center" border="0" cellpadding="2" cellspacing="3">
                              <tr>
                                <td class="hilites" align="left" colspan="2"  style={{width:"50%"}}><b>Customer Details</b></td>
                                <td></td>
                                {/* <td class="hilites" align="center" colspan="2" style={{width:"50%"}}><b>Shop Details</b></td> */}
                              </tr>
                              <tr>
                                <td class="frmlefttb" >Name:</td>
                                <td class="frmrighttb">{estimatedetails.billing_name}</td>
                                {/* <td>-</td> */}
                             {/*    <td class="frmlefttb">Name:</td>
                                <td class="frmrighttb">{orderdetails.delivery_name}</td> */}
                              </tr>
                              <tr>
                                <td class="frmlefttb">Address:</td>
                                <td class="frmrighttb">{estimatedetails.billing_address}</td>
                                {/* <td>-</td> */}
                             {/*    <td class="frmlefttb">Address:</td>
                                <td class="frmrighttb">{orderdetails.delivery_address}</td> */}
                              </tr>
                              <tr>
                                <td class="frmlefttb">State:</td>
                                <td class="frmrighttb">{estimatedetails.billing_state}</td>
                                {/* <td>-</td> */}
                             {/*    <td class="frmlefttb">Address:</td>
                                <td class="frmrighttb">{orderdetails.delivery_address}</td> */}
                              </tr>
                              <tr>
                               {/*  <td class="frmlefttb">City:</td>
                                <td class="frmrighttb">{orderdetails.billing_city}</td> */}
                               {/*  <td>-</td> */}
                              {/*   <td class="frmlefttb">City:</td>
                                <td class="frmrighttb">{orderdetails.delivery_city}</td> */}
                              </tr>
                              <tr>
                             {/*    <td class="frmlefttb">State:</td>
                                <td class="frmrighttb">{orderdetails.billing_state}</td> */}
                               {/*  <td>-</td> */}
                             {/*    <td class="frmlefttb">State:</td>
                                <td class="frmrighttb">{orderdetails.delivery_state}</td> */}
                              </tr>
                              <tr>
                               {/*  <td class="frmlefttb">Postcode:</td>
                                <td class="frmrighttb">{orderdetails.billing_pincode}</td> */}
                                {/* <td>-</td> */}
                               {/*  <td class="frmlefttb">Postcode:</td>
                                <td class="frmrighttb">{orderdetails.delivery_pincode}</td> */}
                              </tr>
                            </table>
                          </td>
                        </tr>
                        {/* <!-- Product Details --> */}
                        <tr>
                          <td>
                            <table width="100%" align="center" cellspacing="1" cellpadding="5" border="0">
                              <tr className='orderdetail-thead'>
                                <td class="hilites orderdetail-td "><b>S.No</b></td>
                                {/* <td class="hilites"><b>Image</b></td> */}
                                <td class="hilites orderdetail-td"><b>Product Name</b></td>
                                <td class="hilites orderdetail-td"><b>Qty</b></td>
                                <td class="hilites orderdetail-td"><b>Price</b></td>
                                
                                <td class="hilites orderdetail-td" align="right"><b>Total</b></td>
                                <td></td>
                                {/* <td class="hilites" align="center"><b>Cancel</b></td> */}
                              </tr>
                              {estimatedetails.estimate_details?.map((product, index) => (
                                  <tr key={product.estimate_detail_id}>
                                    <td>{index + 1}</td>
                                    
                                    <td>
                                   
                                    {product.product_name}
                                      
                                    </td>
                                    <td>{product.qty}</td>
                                    <td>₹{parseFloat(product.amount).toFixed(2)}</td>
                                    <td align="right">₹{parseFloat(product.totalamount).toFixed(2)}</td>
                                    {/* <td align="center">
                                    {parseInt(product.cancel) !== 1 ? ( // Hide cancel button if already canceled
                                        <button
                                          onClick={() => handleCancel(product.order_no)}
                                          title="Cancel Product"
                                          style={{ background: "none", border: "none", cursor: "pointer" }}
                                        >
                                          <i className="ri-close-circle-line" style={{ color: "red" }}></i>
                                        </button>
                                      ):(
                                        <div style={{ color: "red", fontSize: "12px",fontWeight:"bold" }}>(Cancelled)</div>
                                      )
                                    }
                                    </td> */}
                                  </tr>
                                ))}
                              
                              <tr style={{ display:estimatedetails.discount_percentage==="0"?"none":""}}>
                                <td colspan="4" align="right" className="text-end"><b>Sub-Total</b></td>
                                <td align="right">
                                    <b>₹{(estimatedetails?.subtotal ? Number(estimatedetails.subtotal) : 0).toFixed(2)}</b>
                                  </td>

                                <td></td>
                              </tr>
                             {/*  <tr>
                                <td colspan="5" align="right"><b>Discount</b></td>
                                <td align="right">₹0.00</td>
                                <td></td>
                              </tr> */}
                                    {/* {estimatedetails.billing_state?.toLowerCase() === "tamilnadu" ? (                                     
                                       <>
                                        <tr>
                                          <td colSpan="4" align="right" className="text-end"><b>CGST</b></td>
                                          <td align="right">₹{estimatedetails.cgst_amt}</td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td colSpan="4" align="right" className="text-end"><b>SGST</b></td>
                                          <td align="right">₹{estimatedetails.sgst_amt}</td>
                                          <td></td>
                                        </tr>
                                      </>
                                    ) : (
                                      <tr>
                                        <td colSpan="4" align="right" className="text-end"><b>IGST</b></td>
                                        <td align="right">
                                              ₹
                                              {(
                                                parseFloat(estimatedetails.cgst_amt || 0) + parseFloat(estimatedetails.sgst_amt || 0)
                                              ).toFixed(2)}
                                            </td>

                                        <td></td>
                                      </tr>
                                    )} */}

                              {/* <tr>
                                <td colspan="4" align="right" className="text-end"><b>Packing Charge </b></td>
                                <td align="right">₹{estimatedetails.packing_charge}</td>
                                <td></td>
                              </tr> */}
                               <tr style={{ display:estimatedetails.discount_percentage==="0"?"none":""}}>
                                <td colspan="4" align="right" className="text-end"><b>Discount ({estimatedetails.discount_percentage}%) </b></td>
                                <td align="right">₹{estimatedetails.discount_amount}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="4" align="right" className="text-end"><b>Grand Total</b></td>
                                <td align="right"><b>₹{estimatedetails.total}</b></td>
                                <td></td>
                              </tr>
                             
                          
                               
                            </table>
                          </td>
                        </tr>
                     <tr>
                    <td>
                      <form className="theme-form" onSubmit={Handleupdate}>
                      
                        <div className="row mb-3">
                        <div className="row mb-3 col-sm-6"></div>
                          <label className="col-sm-2 col-form-label">Payment Status:</label>
                          <div className="col-sm-4">
                            <select
                              className="form-select"
                              name="status"
                              value={status}
                              onChange={(e) => setStatus(e.target.value)}
                              required
                            >
                              <option value="" disabled>Select Status</option>
                              <option value="Pending">Pending</option>
                              <option value="Paid">Paid</option>
                              {/* <option value="Delivered">Delivered</option> */}
                            </select>
                          </div>
                        </div>

                        <div className="d-flex justify-content-end">
                          <button type="submit" className="btn btn-primary">Update</button>
                        </div>
                      </form>
                    </td>
                  </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default EstimateListDetails;
